<template>
  <div class="flex w-full gap-2">
    <form
      class="flex w-full gap-2"
      :class="{ 'flex-wrap': isLgAndUp || (isLgAndDown && isOpen) }"
      @submit.prevent
    >
      <UiCard
        v-for="venue in filteredValues"
        :key="venue.id"
        tag="label"
        class="block cursor-pointer !rounded-full px-5 py-3 text-sm"
        :class="{ 'w-1/2 truncate': isLgAndDown && !isOpen }"
        :active="venue.id === modelValue"
      >
        <input
          type="checkbox"
          name="timetableVenue"
          :checked="venue.id === modelValue"
          class="size-0 shrink-0 opacity-0"
          @change="
            venue.id === modelValue
              ? $emit('update:modelValue', undefined)
              : $emit('update:modelValue', venue.id)
          "
        />
        <span>{{ venue.title }}</span>
      </UiCard>
    </form>
    <UiButton
      v-if="isLgAndDown && value.length > MAX_VISIBLE_ELEMENTS"
      severity="tertiary"
      class="h-fit p-3"
      :active="isOpen"
      @click="isOpen = !isOpen"
    >
      <UiIcon name="chevron-down" class="size-5" :class="{ 'rotate-180': isOpen }" />
      <div v-if="showChevronHelper" class="absolute right-0 top-0 size-3 rounded-full bg-black" />
    </UiButton>
  </div>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'
import type { Venue } from '@/5_entities/Venue'
import { useBreakpoint } from '@/6_shared/lib'
import { UiButton, UiCard, UiIcon } from '@/6_shared/ui'

const props = defineProps<{
  modelValue?: Venue['id']
  value: Venue[]
}>()
defineEmits<{
  (e: 'update:modelValue', value: Venue['id'] | undefined): void
}>()

const {
  lg: [isLgAndUp, isLgAndDown]
} = useBreakpoint()

const isOpen = ref(false)
const MAX_VISIBLE_ELEMENTS = 2
const filteredValues = computed(() => {
  if (isLgAndUp.value || props.value.length <= MAX_VISIBLE_ELEMENTS || isOpen.value === true)
    return props.value

  return props.value.slice(0, MAX_VISIBLE_ELEMENTS)
})
const showChevronHelper = computed(() => {
  if (!props.modelValue) return false
  const index = props.value.findIndex((item) => item.id === props.modelValue)

  return index >= MAX_VISIBLE_ELEMENTS
})
</script>
